import { Spacing } from '@persona-id/design-tokens';
import { DateTime } from 'luxon';
import { ReactNode, useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import styled from 'styled-components';

import { Container, Header, Section } from 'dashboard/layouts/IndexViewLayoutV2';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { showMessage } from 'dashboard/redux/actions/messages';

const PromptContainer = styled('div')`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: ${Spacing[5]};

  justify-items: center;
`;

const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  svg {
    height: 50px;
    width: 50px;
    color: ${({ theme }) => theme.color.primary.brand};

    *[stroke] {
      stroke: ${({ theme }) => theme.color.primary.brand};
    }
  }
`;

interface DisabledProductFeatureProps {
  title: string;
  headerChildren?: ReactNode;
  prompt: string;
  helpLink: ReactNode;
  icon: ReactNode;
  popupMessage: string;
}

const DisabledProductFeature = ({
  title,
  headerChildren,
  prompt,
  helpLink,
  icon,
  showMessage,
  popupMessage,
}: DisabledProductFeatureProps & PropsFromRedux) => {
  // TODO: Consider refactoring this to just be called on every top level page, and put all the logic
  // for determining what null state to show in here. See
  // https://github.com/persona-id/persona-web/issues/8749
  // for more discussion on this
  useEffect(() => {
    if (popupMessage) {
      showMessage(
        popupMessage,
        MessageType.Notice,
        false,
        DateTime.local().plus({ day: 1 }).toISO(),
      );
    }
  }, [popupMessage, showMessage]);

  return (
    <Container data-test='disabled-product-feature'>
      <Header title={title}>{headerChildren}</Header>
      <Section>
        <PromptContainer>
          <IconContainer>{icon}</IconContainer>
          <p>{prompt}</p>
          {helpLink}
        </PromptContainer>
      </Section>
    </Container>
  );
};

const mapDispatchToProps = {
  showMessage,
};

const connector = connect(null, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DisabledProductFeature);
